import React from "react";
import styled from "styled-components";
import { CorporateTheme, font } from "../../utils/themes";
import { useTheme } from "../../middleware/ThemeContext";

interface StyledTextProps extends React.HTMLAttributes<HTMLElement> {
  fontSize?: string;
  fontWeight?: number;
  lineHeight?: string;
  htmlTag?: any;
  className?: string;
  textColor?: string;
  margin?: string;
  ref?: any;
  fontFamily?: string;
  fontStyle?: string
}

const StyledTag = styled('div')<StyledTextProps>(
  ({ theme, fontSize, fontWeight, lineHeight, textColor, margin, fontFamily, fontStyle }) => ({
    fontSize: fontSize || '14px',
    fontWeight: fontWeight || 600,
    lineHeight: lineHeight || 'normal',
    color: textColor || theme.CorporateTheme.colors.primary,
    margin: margin || 0,
    fontFamily: fontFamily || '"Raleway", sans-serif',
    fontStyle: fontStyle || 'normal'
  })
);

const StyledText: React.FC<StyledTextProps> = ({
  fontSize,
  fontWeight,
  fontFamily,
  lineHeight,
  htmlTag: Tag = "div",
  className,
  fontStyle,
  ref,
  textColor,
  children,
  margin,
  ...rest
}) => {
  const { theme } = useTheme();
  return (
    <StyledTag
      theme={theme}
      as={Tag}
      ref={ref}
      fontSize={fontSize}
      fontFamily={fontFamily}
      fontWeight={fontWeight}
      fontStyle={fontStyle}
      lineHeight={lineHeight}
      textColor={textColor}
      margin={margin}
      className={className}
      {...rest}
    >
      {children}
    </StyledTag>
  );
};

export default StyledText;
